export default __webpack_public_path__ + "static/media/bt_logo_dark.4e35938e.svg";